const cookieUtils = {

    createCookie(name, value, days) {
        let expires;
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        } else {
            expires = "";
        }

        document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/; Secure";
    },

    readCookie(name) {
        var cname         = name + "=";
        var cleanCookies  = cookieUtils.deleteGigLLUPart(document.cookie)
        var decodedCookie = decodeURIComponent(cleanCookies);
        var ca            = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cname) == 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return null;
    },

    removeCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },

    getFirstCookieValue(cookieId) {
        const cookieValue = cookieUtils.readCookie(cookieId);
        return cookieValue ? cookieValue.split(',')[0] : '';
    },

    //this has a super weird eincoding which breaks for non ascii characters if they are transmitted from CDC
    //so just remove this part from the cookie collection we have... they are not used here anyway
    deleteGigLLUPart(cookies) {
        var llu = '_gig_llu=';
        if(cookies.includes(llu)) {
            var startPos = cookies.indexOf(llu);
            var endPos = cookies.indexOf(';', startPos+1);
            var firstpart = cookies.substring(0,startPos);
            var secondpart = cookies.substring(endPos+1, cookies.length);
            return firstpart.concat(secondpart);
        }
        return cookies
    }
};

(function () {
    // Call the method initially
})();

export default cookieUtils;